import { int, text } from '@/hooks/useUrlState';

/**
 * The /tabs query string, in this order (see README "List pages, URL state"): one search drives both
 * grids, each grid has its own page and page size. There is no `page` key: a change of the search
 * patches both page numbers back to 1 itself.
 */
export const tabsUrlSchema = {
  search: text(),
  unpaidPage: int({ min: 1 }, 1),
  unpaidSize: int({ min: 1, max: 500 }, 25),
  othersPage: int({ min: 1 }, 1),
  othersSize: int({ min: 1, max: 500 }, 25),
};
